import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import memoizedPartial from 'shared/utils/memoized-partial';
import { VODCSSModules } from 'shared/utils/wix-connect';

import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { getAllSettings } from 'shared/selectors/app-settings';

import ContentSlider from '../content-slider/content-slider';
import VideoListItem from '../video-list-item/video-list-item';
import styles from './videos.styl';

@connect(state => ({
  videoByIds: getVideosGroupedByIds(state),
  appSettings: getAllSettings(state),
}))
@VODCSSModules(styles)
export default class Videos extends React.Component {

  static propTypes = {
    appSettings: React.PropTypes.object,
    channelData: React.PropTypes.object,

    videoByIds: React.PropTypes.object,
    channelVideoIds: React.PropTypes.array,
    prevPageIds: React.PropTypes.array,
    nextPageIds: React.PropTypes.array,

    thumbnailSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number,
    }),

    onSlideToPrev: React.PropTypes.func,
    onSlideToNext: React.PropTypes.func,

    onThumbnailClick: React.PropTypes.func,
    onPlayClick: React.PropTypes.func,
  };

  @autobind
  renderVideoItem(videoId) {
    const {
      channelData,
      appSettings,
      videoByIds,
      thumbnailSize,
      onThumbnailClick,
      onPlayClick,
    } = this.props;

    const videoItem = videoByIds[videoId];

    return (
      <VideoListItem className={styles['thumbnail-wrapper']}
                     channelData={channelData}
                     appSettings={appSettings}
                     key={videoId}
                     thumbnailSize={thumbnailSize}
                     videoItem={videoItem}
                     onClick={memoizedPartial(onThumbnailClick, videoItem)}
                     onPlayClicked={memoizedPartial(onPlayClick, videoItem)} />
    );
  }

  get prevSlide() {
    const { prevPageIds } = this.props;
    return _.map(prevPageIds, this.renderVideoItem);
  }

  get nextSlide() {
    const { nextPageIds } = this.props;
    return _.map(nextPageIds, this.renderVideoItem);
  }

  get currentSlide() {
    const { channelVideoIds } = this.props;
    return _.map(channelVideoIds, this.renderVideoItem);
  }

  render() {
    const { onSlideToPrev, onSlideToNext } = this.props;

    return (
      <ContentSlider styleName="container"
                     goBack={onSlideToPrev}
                     goForward={onSlideToNext}
                     prevSlide={this.prevSlide}
                     currentSlide={this.currentSlide}
                     nextSlide={this.nextSlide} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/videos/videos.js